import { Dispatch, ReducerState, ReducerAction, createContext } from "react";
import FiltersReducer from "./filters.reducer";

type FiltersReducerState = ReducerState<typeof FiltersReducer>;
type FiltersDispatchAction = Dispatch<ReducerAction<typeof FiltersReducer>>;
type FiltersContextType = [FiltersReducerState, FiltersDispatchAction];

export const FiltersContext = createContext<FiltersContextType>([{}, (state) => state]);
